import React from "react"
import {Box, Container, Paper} from "@material-ui/core"
import SidebarItem from "./SidebarItem"
import sidebarImage1 from "../images/moms6.jpeg"
import sidebarImage2 from "../images/dawn.png"
import sidebarImage3 from "../images/miles2.png"
import sidebarImage4 from "../images/daisy.png"
import sidebarImage5 from "../images/mike.png"
import sidebarImage6 from "../images/woofles.png"
import sidebarImage7 from "../images/woofles2.png"
import milesAvatar from "../images/milesavatar.png"
import jasonAvatar from "../images/jay4.png"
import partyImage from "../images/moms3.png"
import boysImage from "../images/kids1.jpeg"
import myselfAvatar from "../images/myself.png"
import goatAvatar from "../images/goat.png"
import californiaImage from "../images/moms4.jpeg"
import tattooImage from "../images/tattoo.png"
import whitmerImage from "../images/governor.jpg"
import guillotineImage from "../images/mom9.png"
import commandoImage from "../images/commando.png"
import broomImage from "../images/brooms.png"
import famImage from "../images/fam2.png"
import fam2Image from "../images/fam1.png"
import usImage from "../images/us.png"
import holdingImage from "../images/miles4.png"
import guitarImage from "../images/jayLeland.png"
import TestimonialCard from "./TestimonialCard"

const ContentView = () => {
    return (
        <Container className="content-box">
            <Box>
                <h1 className="content-headline">Best Moms In The World Chosen For 2021</h1>
            </Box>
            <Box className="content-main">
                <Paper className="content-article">
                    <img src={partyImage} className="image-hero" alt={"It's a Hot Time at the Box Factory"} />
                    <caption className="photo-caption">Karen Moldovan and Kate Mood celebrate their award at a local Denny's</caption>

                    <Box className="content-block">
                        <h2>It's Official!</h2>
                        <Box className="byline">May 9, 2021 - Benton Harbor, MI</Box>
                        <p>
                            This year's Best Moms in the World have been chosen by our industry-leading mom experts.  We measured the
                            awesomeness of moms across the globe, and by metrics known only to us have managed to calculate this year's winners.
                        </p>
                            <p>Despite their perennial competition from Britney, the honors once again go to Kate Mood and Karen Moldovan of Benton Harbor, MI USA!
                                We caught up with several of Kate and Karen's friends and family to get the details on what these award-winning moms are bringing to the table.
                                Read on to discover the secrets of being amazing...</p>

                    </Box>

                    <Box className="content-block">
                        <Box className="image-section">
                            <img src={boysImage} alt="Matt and James" className="image-hero" />
                            <p>
                                The pair has been selected primarily for gifting the world with an incredibly talented, wonderful son whose brilliant success
                                and charitable acts have only been surpassed by his skill at crafting websites.  <br />They also raised a son named Jason.
                            </p>
                        </Box>
                    </Box>

                    <Box className="content-block">
                        <h2>You can't be the best without being the coolest</h2>
                        <p>A major factor in this year's deliberations was definitely the cool factor. Kate and Karen showed off their
                            badass lifestyle choices by hitting the road and vacationing the pandemic away in sunny California!</p>
                        <img src={californiaImage} className="image-hero" alt={"Warm and toasty"} />
                        <caption className="photo-caption">Karen celebrates after running over a homeless man. 200 points!</caption>

                        <p>In a true display of coolness, Kate even got a new tattoo while in the Eureka State.  The artist who performed the work asked not to be
                        named for fear of reprisal, but said that Kate "seemed to be very happy with the design, she even paid me real money!".</p>

                        <img src={tattooImage} className="image-hero" alt={"Biker tattoos are the new knitting needles"} />
                        <caption className="photo-caption">We've been told that tattoos do not in fact reliably indicate gang membership</caption>
                    </Box>

                    <Box className="content-block">
                        <h2>You can't be the best without community involvement</h2>
                        <Box className="image-section">
                            <Box className="image-text-block">
                                <p>
                                    An important leadership quality that most business textbooks list is giving back to the community.  As local business leaders, our winners
                                    are no strangers to getting their hands dirty and helping others.  Whether it's volunteering with local underserved kids, successfully kidnapping the governor where others have pathetically failed,
                                    or supporting the art and LGTBQ+ scenes in their adopted hometown, these moms know how to set a shining example of community spirit!
                                </p>
                                <p className="tiny-text">dear NSA that was a joke</p>
                            </Box>
                            <img src={whitmerImage} alt="Never send a bunch of ignorant Tacticool men to do a woman's job" className="image-hero" />

                        </Box>
                        <Box className="image-section">
                                <img src={guillotineImage} alt="See above" className="image-hero" />
                                <Box className="image-text-block">
                                    <p>
                                        Never one to let injustice fall through the cracks, Karen founded a local political action group that holds
                                        our democratically elected representatives to account for their deeds.  While positively encouraging those leaders who
                                        demonstrate compassion and care for the community, Karen occasionally puts her skills to use crafting bespoke guillotines
                                        for when peaceful protest fails!
                                    </p>
                                    <p className="tiny-text lefty">also a joke my friends</p>
                                </Box>
                        </Box>
                    </Box>
                    <Box className="content-block">
                        <h2>You can't be the best without discipline</h2>
                        <img src={commandoImage} className="image-hero" alt={"But look how great we turned out"} />
                        <caption className="photo-caption">Oh you didn't know about Commando Mom?</caption>
                        <p>Nuff said.</p>
                    </Box>

                    <Box className="content-block">
                        <h2>You can't be the best without ingenuity</h2>
                        <p>Nowadays, thinking outside the box is practically mandatory.  Living in California inspired Karen to design a truly no-carbon-footprint personal mobility system
                        that is set to revolutionize the short-trip transportation industry. Here she can be seen distracting several amazed tollbooth operators so her whole crew can get through without paying a dime!
                        Now that's using your head, Karen. Way to go!</p>

                        <img src={broomImage} className="image-hero" alt={"It's a bird! It's a plane! It's Karen!"} />
                        <caption className="photo-caption">Showing off her zero-emissions whip to the jealous peasants and their outmoded fossil fuels</caption>
                    </Box>

                    <Box className="content-block">
                        <h2>You can't be the best without family</h2>
                        <p>
                            Since the award is literally defined by parenting skill, it's very difficult to even be considered without family of some kind.  But Kate and Karen come through in spades!
                            Despite the sacrifice and stress and worry involved in raising Jason, these moms by sheer awesomeness have nurtured a burgeoning family that consists of several smart and capable grandchildren,
                            an amazing daughter-in-law, innumerable happy and healthy animal kiddos, and even Jason is technically considered to have turned out mostly OK.
                        </p>
                        <img src={famImage} className="image-hero" alt={"This lovely family got photo-bombed by an entitled white guy"} />
                        <caption className="photo-caption">This lovely family got photo-bombed by an entitled white guy. Typical.</caption>
                        <br />
                        <img src={usImage} className="image-hero" alt={"Well isn't this a handsome couple"} />
                        <caption className="photo-caption">Kate and Karen's often-admired and frankly more important son Matt and his long-suffering fiancee. And a cow.</caption>
                    </Box>
                    <Box className="content-block">
                        <Box className="image-section">
                            <img src={holdingImage} alt="Kate and Miles" className="image-hero" />
                            <img src={guitarImage} alt="Jay and Leland" className="image-hero" />
                        </Box>
                    </Box>
                    <Box className="content-block">
                        <img src={fam2Image} className="image-hero" alt={"I guess he's alright"} />
                        <caption className="photo-caption">Jason, Kat and the boys, working at their side business making those photos that are in the picture frames you buy at Target</caption>
                    </Box>
                </Paper>

                <Box className="content-sidebar">
                    <Box className="sidebar-header">What do our readers think?</Box>
                    <Paper className="sidebar-testimonials">
                        <TestimonialCard
                            name="Miles M"
                            image={milesAvatar}
                            content={"These are pretty good moms for sure.  They're pretty great with babies, I've been alive for months now and they've always treated me very well.  I'd say overall Kate and Karen definitely qualify for the title this year."}
                            project={"Disestablishmentarianist"}
                            className="sidebar-testimonial"
                        />
                        <TestimonialCard
                            name="Matt M"
                            image={myselfAvatar}
                            content={"They may have been the only moms I've ever known, but I always knew they were the best.  When I heard about this site and this award, I had a feeling they would be on this page sooner or later. Love you guys!"}
                            project={"Prominent Offspring"}
                            className="sidebar-testimonial"
                        />
                        <TestimonialCard
                            name="Billy G"
                            image={goatAvatar}
                            content={"I used to know some chickens who spoke very highly of both Karen and KT.  Very loving and caring, never forgot a feeding, and even commissioned very tasteful French housing if I recall. If I ever got the chance to live in their yard I would take it, yes indeed."}
                            project={"Knowledgeable and Wise But Somewhat Gruff"}
                            className="sidebar-testimonial"
                        />
                        <TestimonialCard
                            name="Jason M"
                            image={jasonAvatar}
                            content={"Wow I wish I had thought of something like this for Mother's Day."}
                            project={"Secondary Child"}
                            className="sidebar-testimonial"
                        />
                    </Paper>

                    <Box className="sidebar-header">Related Articles</Box>
                    <SidebarItem title={"Harvard study finds that ice cream is now good for you, creating a McFlurry of investment opportunities"} image={sidebarImage1} />
                    <SidebarItem title={"Local mom discovers her baby has super powers, can already say \"Disestablishmentarianism\""} image={sidebarImage3} />
                    <SidebarItem title={"Best Dog in the World announces desire to snuggle with Best Moms in the World"} image={sidebarImage6} />
                    <SidebarItem title={"Teen floods basement by crying for 3 full days, finally cured by being sat on"} image={sidebarImage4} />
                    <SidebarItem title={"CA man reveals one weird trick for quitting methamphetamines in 7 days or less"} image={sidebarImage5} />
                    <SidebarItem title={"Best Dog in the World announces that he has even been practicing and look at his little ear"} image={sidebarImage7} />
                    <SidebarItem title={"Librarian finds $30k in a sock, gets diamond piercing"} image={sidebarImage2} />
                </Box>

            </Box>
        </Container>
    )
}

export default ContentView